export default function LocalPostsWidget() {
  return (
    <div className="w-full my-12">
      



      
      
    </div>);

}